import type { FC } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { getTestIdByParts } from 'utils/getTestIdByParts';
import type { WithTestId } from 'types/app';

import { Button } from '@Atomic/atoms/Button';
import { Icons } from '@Atomic/atoms/Icons';

import styles from './goodPriceLink.module.scss';
import { GoodPriceModal } from './GoodPriceModal';

export type GoodPriceLinkProps = WithTestId<{
  className?: string;
}>;

/**
 * «✓ Хорошая цена ›» text link on the offer page; opens the explainer modal (BP-8273).
 * Figma «Button Links» M — the atom's `variant="text"`, with the size tier's box zeroed here.
 */
export const GoodPriceLink: FC<GoodPriceLinkProps> = ({
  className,
  testId = 'good-price-link',
}) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <span className={cn(styles.wrapper, className)}>
      <Button
        variant="text"
        intent="success"
        size="medium"
        className={styles.link}
        iconLeft={<Icons.ConfirmationFill />}
        iconRight={<Icons.ChevronRight />}
        onClick={() => setIsModalOpen(true)}
        aria-haspopup="dialog"
        aria-expanded={isModalOpen}
        testId={testId}
      >
        {t('goodPrice.label')}
      </Button>

      <GoodPriceModal
        visible={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        testId={getTestIdByParts(testId, 'modal')}
      />
    </span>
  );
};
